import { render } from "./NewSubArea.vue?vue&type=template&id=9fb05a54&scoped=true"
import script from "./NewSubArea.vue?vue&type=script&lang=js"
export * from "./NewSubArea.vue?vue&type=script&lang=js"

import "./NewSubArea.vue?vue&type=style&index=0&id=9fb05a54&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb05a54"]])

export default __exports__